function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12.5,
  cy: 12.5,
  r: 12.5,
  fill: "#F5F8FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.6807 15.7135L8.7499 12.3297C8.40858 12.0188 8.41825 11.4841 8.7706 11.1854C9.06967 10.9318 9.51393 10.9392 9.8042 11.2025L12.5 14.3622L15.1958 11.2025C15.4861 10.9392 15.9303 10.9318 16.2294 11.1854C16.5817 11.4841 16.5914 12.0188 16.2501 12.3297L13.3193 15.7135C13.3193 15.7135 12.9842 16 12.5 16C12.0158 16 11.6807 15.7135 11.6807 15.7135Z",
  fill: "#011FBB"
});

const SvgListExpand = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgListExpand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list_expand.dd0eb9a7.svg";
export { ForwardRef as ReactComponent };